<div class="row mt-lg-4">
  <nav class="pagination-wrapper justify-content-center" aria-label="Pagination Navigation">
    <ul class="pagination">
      <li class="page-item" [class.disabled]="currentPage === 1 || currentPage=== 0">
        <a class="page-link" href="#" (click)="onPageChange(currentPage - 1)" aria-label="Previous Page">
          <svg class="icon icon-primary"><use href="/bootstrap-italia/dist/svg/sprites.svg#it-chevron-left"></use></svg>
          <span class="visually-hidden">Pagina precedente</span>
        </a>
      </li>
      <li class="page-item active" *ngFor="let page of pages" [class.active]="page === currentPage">
        <a class="page-link" href="#" [attr.aria-current]="page === currentPage ? 'page' : null" (click)="onPageChange(page)" *ngIf="page !== '...'; else ellipsisTemplate">
          {{ page }}
        </a>
        <ng-template #ellipsisTemplate>
          <span class="page-link">{{ page }}</span>
        </ng-template>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" href="#" (click)="onPageChange(currentPage + 1)" aria-label="Next Page">
          <span class="visually-hidden">Pagina successiva</span>
          <svg class="icon icon-primary"><use href="/bootstrap-italia/dist/svg/sprites.svg#it-chevron-right"></use></svg>
        </a>
      </li>
    </ul>
  </nav>
</div>
